module.exports = __webpack_public_path__ + "img/fa-shop.7f591f7.svg";